export default __webpack_public_path__ + "static/media/aesthetician_services.b89b1984.pdf";